<template>
  <div class="rule-budget-wrapper">
    <b-alert
      class="ml-0"
      v-if="!!alert.message"
      show
      :variant="alert.type"
      dismissible
      @dismissed="$_dismissAlert()"
    >
      <div v-html="alert.message"></div>
    </b-alert>
    <RuleBidOptions
      :template="config.budgetConfig.budgetModelTemplates[ruleModel.rule.components.budget.template]"
      :action-options="actionOptions"
      :to-options="config.budgetConfig.budgetToOptions"
      :unit-options="config.budgetConfig.budgetUnitOptions"
      v-model="form"
      :bid="ruleModel.rule.components.budget"
      @max-limit-exhausted="$_maxLimitExhausted"
      name="Budget"
      ref="ruleBidOptions"
    />
    <RuleMinMax v-if="$c_showMinMax"
                name="Budget"
                :min="form.min"
                :minObject="form.minObject"
                @min="$_handleMin"
                @minObject="$_handleMinObject"
                :max="form.max"
                :maxObject="form.maxObject"
                @max="$_handleMax"
                @maxObject="$_handleMaxObject"
                @spread="$_handleSpread"
                :spread="form.spread"
                :unit="ruleModel.rule.rule_action"
                :limits="ruleModel.rule.components.budget.limits"
                ref="ruleMinMax"
                :showMinMax="showMinMax"
                :action="$c_currentAction"
    />
  </div>
</template>

<script>
import RuleBidOptions from './subcomponents/RuleBidOptions.vue';
import RuleMinMax from './subcomponents/RuleMinMax.vue';
import component from '../mixins/component';

export default {
  name: 'RuleBudget',
  components: { RuleBidOptions, RuleMinMax },
  mixins: [component],
  props: {
    value: {
      type: Object,
      default: () => ({
        action: 'set', unit: 'static', to: '', value: '', min: '', max: '', minObject: { unit: 'static', to: '', value: '' }, maxObject: { unit: 'static', to: '', value: '' },
      }),
    },
    showMinMax: { type: Boolean, default: true },
    type: { type: String, default: '' },
    actionOptions: { type: Array, default: () => [] },
  },
  data() {
    return {
      form: {},
      info: this.ruleModel.rule.components.budget.info,
      alert: {
        type: 'danger',
        message: '',
      },
    };
  },
  computed: {
    $c_showMinMax() {
      return !(['set', 'spread'].includes(this.form.action) && this.form.unit === 'static');
    },
    $c_currentAction() {
      return this.form.action;
    },
  },
  watch: {
    form: {
      handler() {
        if (!this.$c_showMinMax) {
          this.form.minObject.value = this.form.value;
          this.form.maxObject.value = this.form.value;
          this.form.min = this.form.value;
          this.form.max = this.form.value;
        }
        this.$_emit('form');
      },
      deep: true,
    },
    $c_showMinMax() {
      this.form.minObject = { unit: 'static', to: '', value: '' };
      this.form.maxObject = { unit: 'static', to: '', value: '' };
      this.form.min = '';
      this.form.max = '';
    },
  },
  created() {
    this.form = this.value;
  },
  methods: {
    async validate() {
      try {
        const subcomponentsStatus = [];
        Object.values(this.$refs).forEach((ref) => {
          if (ref) {
            subcomponentsStatus.push(ref.validate());
          }
        });
        const validStatuses = await Promise.all([...subcomponentsStatus]);
        if (validStatuses.includes(false)) {
          return false;
        }
        return true;
      } catch (error) {
        return false;
      }
    },
    async $_maxLimitExhausted() {
      const swal = await this.$swal({
        title: 'budget seems unusually high!',
        type: 'warning',
        allowOutsideClick: false,
        showCancelButton: true,
        confirmButtonText: 'Keep Anyway',
        cancelButtonText: 'Reset',
      });
      if (swal.value !== true) this.form.value = '';
    },
    $_handleMax(value) {
      this.form.max = value;
    },
    $_handleMaxObject(maxObject) {
      if (this.form.maxObject) {
        this.form = { ...this.form, maxObject };
      }
    },
    $_handleMin(value) {
      this.form.min = value;
    },
    $_handleMinObject(minObject) {
      if (this.form.minObject) {
        this.form = { ...this.form, minObject };
      }
    },
    $_handleSpread(value) {
      this.form.spread = value;
    },
    $_isValid() {
      const action = this.$c_currentAction;
      if (this.form.value === '') {
        return { valid: false, where: 'Budget field' };
      }
      if (action === 'increase' || action === 'decrease') {
        if ((this.form.min === '' || this.form.max === '')) {
          return { valid: false, where: 'Min/Max fields' };
        }
        return { valid: true };
      }
      return { valid: true };
    },
    $_showInlineError(variant, message) {
      this.$_showAlert(variant, message);
    },
    $_showAlert(type, message) {
      this.alert.type = type;
      this.alert.message = message;
    },
    $_dismissAlert() {
      this.alert.message = '';
    },
  },
};
</script>

<style lang="scss">
// .rule-budget-wrapper {
//   .least-one-checkbox-message {
//     position: relative;
//     top: -17px;
//   }
//   .limit-input-wrapper {
//     width: 500px;
//     .state-addon {
//       width: 320px;
//       @media only screen and (max-width : 575px) {
//         width: 150px;
//       }
//     }
//     input.form-control {
//       text-align: center;
//     }
//     .input-group-addon {
//       &:last-child {
//         text-align: center;
//         display: inline-block;
//       }
//     }
//   }
// }
.rule-budget-description {
  font-size: 80%;
  margin-top: 1rem !important;
  margin-left: .5rem;
}
.rule-budget-wrapper{
  .custom-control-label{
    padding-top:.2rem !important;
  }
}
</style>
